import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Drama } from "lucide-react";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-center">
      <Seo title="Page not found" noindex />
      <Drama className="mx-auto h-10 w-10 text-[hsl(var(--gold))]" />
      <h1 className="mt-4 font-serif text-4xl font-semibold">Page not found</h1>
      <p className="mt-3 text-muted-foreground">
        That page doesn't exist, or it has moved. Try one of these instead.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground hover:bg-[#B82332]">
          Home
        </Link>
        <Link to="/shows" className="rounded-full border border-border px-6 py-3 text-sm font-medium hover:bg-secondary">
          Browse shows
        </Link>
        <Link to="/theatre-guide" className="rounded-full border border-border px-6 py-3 text-sm font-medium hover:bg-secondary">
          Theatre A-Z
        </Link>
      </div>
    </div>
  );
}